import {inject, Injectable} from "@angular/core";
import {StartIndexedDbService} from "./indexeddb.service";
import {EObjectStore} from "../enums/objectStore.enum";
import { IIncentive } from "projects/lib-ui/src/shared/interfaces/incentive";

@Injectable({
  providedIn: 'root',
})
export class IndexedDbIncentiveService {
  private readonly startIndexedDbService = inject(StartIndexedDbService);
  private readonly db: IDBDatabase | null = this.startIndexedDbService.db;

  public add(item: IIncentive): Promise<IIncentive> {
    return new Promise((resolve, reject) => {
      if (!this.db) {
        return reject(new Error('Banco de dados incentivo não foi inicializado'));
      }
      this.clearDB().then(() => {
        const request = this.initTransaction('readwrite').add(item);

        request.onsuccess = () => resolve(item);

        request.onerror = () =>
          reject(new Error('Erro ao adicionar incentivo ao banco de dados'));
      });
    });
  }

  public get(): Promise<IIncentive | null> {
    return new Promise((resolve, reject) => {
      if (!this.db) {
        return reject(new Error('Banco de dados incentivo não foi inicializado'));
      }

      const request = this.initTransaction('readonly').getAll();

      request.onsuccess = () => resolve(request.result[0] ?? null);

      request.onerror = () => reject(new Error('Erro ao buscar incentivo'));
    });
  }

  public clearDB(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.db) {
        return reject(new Error('Banco de dados não foi inicializado'));
      }

      const request = this.initTransaction('readwrite').clear();

      request.onsuccess = () => resolve();
      request.onerror = () =>
        reject(new Error('Erro ao limpar o banco de dados'));
    });
  }

  private initTransaction(
    permission: 'readwrite' | 'readonly'
  ): IDBObjectStore {
    return this.db!.transaction([EObjectStore.INCENTIVE], permission).objectStore(
      EObjectStore.INCENTIVE
    );
  }
}
